import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp, Loader2 } from 'lucide-react';
import axios from 'axios';
import { API } from '../../constants';

const FALLBACK_FAQS = [
  { id: 'f1', question: 'Koľko stojí renovácia svetlometov?', answer: 'Cena závisí od typu a stavu svetlometov. Výmena plexiskla od 120€/ks, PPF ochrana od 50€/ks. Repas a oprava svetlometov je na dopyt – kontaktujte nás pre presnú kalkuláciu na +421 915 264 064.', active: true },
  { id: 'f2', question: 'Ako dlho trvá renovácia svetlometov?', answer: 'Jednoduchá renovácia trvá 2-3 hodiny. Výmena plexiskla alebo kompletný repas môže trvať 1-2 pracovné dni. Vždy vás vopred informujeme o termíne.', active: true },
  { id: 'f3', question: 'Aké typy svetlometov existujú?', answer: 'Existuje viacero typov: halogénové (najbežnejšie), xenónové (HID), LED a laserové. Každý typ má svoje výhody – halogény sú lacné na údržbu, LED a xenón svietia silnejšie a dlhšie.', active: true },
  { id: 'f4', question: 'Čo je hviezdny strop a koľko stojí?', answer: 'Hviezdny strop je luxusná úprava interiéru auta s optickými vláknami, ktoré vytvárajú efekt hviezdnej oblohy. Cena začína od 700€ a závisí od počtu vlákien a veľkosti stropu.', active: true },
  { id: 'f5', question: 'Čo je ambient osvetlenie?', answer: 'Ambient osvetlenie je dekoratívne LED osvetlenie interiéru vozidla – dvere, palubná doska, stredová konzola. Vytvára príjemný a luxusný pocit. Cena od 300€, dostupné v rôznych farbách.', active: true },
  { id: 'f6', question: 'Poskytujete záruku na vaše služby?', answer: 'Áno, na renováciu svetlometov je záruka 12 mesiacov, na inštaláciu LED osvetlenia a hviezdneho stropu 24 mesiacov.', active: true },
  { id: 'f7', question: 'Kde sa nachádzate a aké sú otváracie hodiny?', answer: 'Nachádzame sa na adrese Šípková 5, 900 27 Bernolákovo. Otváracie hodiny: Pondelok - Piatok 8:00-17:00, Sobota 8:00-13:00. Nedeľa zatvorená.', active: true },
  { id: 'f8', question: 'Aké značky áut servisujete?', answer: 'Servisujeme všetky značky – BMW, Audi, Mercedes, VW, Škoda, Ford, Toyota a ďalšie. Od osobných áut cez SUV až po dodávky.', active: true },
  { id: 'f9', question: 'Čo je PPF ochrana svetlometov?', answer: 'PPF (Paint Protection Film) je ochranná fólia, ktorá chráni svetlomety pred poškodením od kamienkov, UV žiarenia a chemikálií. Fólia je priehľadná a neovplyvňuje svietivosť. Cena od 50€/ks.', active: true },
  { id: 'f10', question: 'Je potrebné objednať sa vopred?', answer: 'Áno, odporúčame objednať sa vopred telefonicky na +421 915 264 064 alebo cez rezervačný formulár na našej stránke.', active: true },
  { id: 'f11', question: 'Kedy treba vymeniť plexisklá svetlometov?', answer: 'Keď sú viditeľne zožltnuté, poškrabané alebo zarosené zvnútra. Opotrebované plexisklá znižujú svietivosť až o 40% a môžu ohroziť bezpečnosť.', active: true },
  { id: 'f12', question: 'Aký je rozdiel medzi LED a xenónovými svetlami?', answer: 'Xenón produkuje svetlo elektrickým oblúkom v plyne a má teplý biely tón. LED používa diódy, je úspornejší, má dlhšiu životnosť a umožňuje adaptívne svietenie.', active: true },
  { id: 'f13', question: 'Prečo sa svetlomety zahmlievajú?', answer: 'Najčastejšia príčina je poškodené tesnenie. Vlhkosť sa dostane dovnútra a kondenzuje. Riešením je výmena tesnenia a vysušenie svetlometu.', active: true },
  { id: 'f14', question: 'Sú LED svetlá lepšie ako halogény?', answer: 'Vo väčšine parametrov áno: silnejšie svetlo, nižšia spotreba, dlhšia životnosť. Nevýhoda: vyššia cena a zložitejšia výmena.', active: true },
  { id: 'f15', question: 'Ako sa starať o svetlomety?', answer: 'Pravidelne ich čistite, kontrolujte nastavenie, chráňte PPF fóliou a vymeňte žiarovky včas. Odporúčame kontrolu minimálne raz ročne.', active: true },
  { id: 'f16', question: 'Robíte aj diagnostiku svetlometov?', answer: 'Áno, ponúkame bezplatnú obhliadku a diagnostiku stavu svetlometov. Prídite k nám alebo si rezervujte termín online.', active: true },
  { id: 'f17', question: 'Čo je DRL (denné svietenie)?', answer: 'DRL (Daytime Running Lights) sú svetlá, ktoré svietia počas dňa pre lepšiu viditeľnosť vozidla. Opravujeme a inštalujeme DRL pre všetky značky áut.', active: true },
  { id: 'f18', question: 'Koľko stojí demontáž a montáž nárazníka?', answer: 'Demontáž a montáž nárazníka stojí 40€. Táto služba je často potrebná pri renovácii svetlometov alebo inštalácii DRL.', active: true },
  { id: 'f19', question: 'Ako sa dostanem k vám do prevádzky?', answer: 'Nachádzame sa na Šípkovej 5 v Bernolákove, len 15 minút od Bratislavy. Máme vlastné parkovisko priamo pred prevádzkou.', active: true },
  { id: 'f20', question: 'Prijímate platbu kartou?', answer: 'Áno, prijímame platbu v hotovosti aj kartou. Pre väčšie zákazky je možné dohodnúť aj splátky.', active: true },
];

export const FAQSection = () => {
  const [faqs, setFaqs] = useState(FALLBACK_FAQS);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await axios.get(`${API}/faq`);
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          setFaqs(response.data);
        }
      } catch (error) {
        // Keep fallback FAQs
      }
    };
    fetchFAQs();
  }, []);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white/[0.02]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00BFFF] mb-4">
            FAQ
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl tracking-tight font-medium">
            Časté otázky
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          {loading ? (
            <div className="flex justify-center py-12">
              <Loader2 className="w-8 h-8 animate-spin text-[#00BFFF]" />
            </div>
          ) : (
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={faq.id}
                  data-testid={`faq-item-${index}`}
                  className="border-b border-white/10"
                >
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full flex items-center justify-between py-5 text-left"
                  >
                    <span className="font-medium pr-8">{faq.question}</span>
                    {openIndex === index ? (
                      <ChevronUp className="w-5 h-5 text-[#00BFFF] flex-shrink-0" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-zinc-400 flex-shrink-0" />
                    )}
                  </button>
                  {openIndex === index && (
                    <div className="pb-5 text-zinc-400 animate-fadeIn">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
